/**
 * custom.product-claims.js
 * Carousel de claims de produto para a seção custom.product-claims-carousel.
 * Fruy — Vanilla JS, sem dependências externas.
 */

(function () {
  'use strict';

  var AUTO_ADVANCE_MS = 4000;

  /**
   * Inicializa todos os carousels na página.
   */
  function initCarousels() {
    var carousels = document.querySelectorAll('[data-claims-carousel]');
    carousels.forEach(function (carousel) {
      initSingleCarousel(carousel);
    });
  }

  /**
   * Inicializa um carousel individual.
   * @param {HTMLElement} carousel
   */
  function initSingleCarousel(carousel) {
    var slides = Array.from(carousel.querySelectorAll('[data-slide-index]'));
    if (slides.length === 0) return;

    // Localiza os indicadores no mesmo bloco-pai (section)
    var section = carousel.closest('.custom-claims') || carousel.parentElement;
    var indicators = section
      ? Array.from(section.querySelectorAll('[data-indicator-index]'))
      : [];

    var currentIndex = 0;
    var autoAdvanceTimer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /**
     * Ativa o slide pelo índice, aplicando classes de animação.
     * @param {number} nextIndex
     */
    function goToSlide(nextIndex) {
      if (nextIndex === currentIndex) return;
      if (nextIndex < 0) nextIndex = slides.length - 1;
      if (nextIndex >= slides.length) nextIndex = 0;

      var current = slides[currentIndex];
      var next = slides[nextIndex];

      // Aplica classes de saída/entrada
      current.classList.remove('custom-claims-slide--active');
      current.classList.add('custom-claims-slide--exiting');
      current.setAttribute('hidden', '');

      next.classList.remove('custom-claims-slide--exiting');
      next.removeAttribute('hidden');

      if (!reducedMotion) {
        next.classList.add('custom-claims-slide--entering');
        // Remove a classe de entering após a animação terminar
        next.addEventListener('animationend', function onEntered() {
          next.classList.remove('custom-claims-slide--entering');
          next.removeEventListener('animationend', onEntered);
        });
      }

      next.classList.add('custom-claims-slide--active');

      // Remove exiting do atual após transição
      var exitDuration = reducedMotion ? 0 : 300;
      setTimeout(function () {
        current.classList.remove('custom-claims-slide--exiting');
      }, exitDuration);

      // Atualiza aria no carousel
      carousel.setAttribute('aria-label', 'Slide ' + (nextIndex + 1) + ' de ' + slides.length);

      // Atualiza indicadores
      updateIndicators(nextIndex);

      currentIndex = nextIndex;
    }

    /**
     * Atualiza o estado dos indicadores (pill).
     * @param {number} activeIndex
     */
    function updateIndicators(activeIndex) {
      indicators.forEach(function (indicator, i) {
        var isActive = i === activeIndex;
        indicator.classList.toggle('custom-claims-indicator--active', isActive);
        indicator.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    /**
     * Inicia o auto-avanço.
     */
    function startAutoAdvance() {
      if (reducedMotion) return; // Respeita prefers-reduced-motion
      stopAutoAdvance();
      autoAdvanceTimer = setInterval(function () {
        goToSlide(currentIndex + 1);
      }, AUTO_ADVANCE_MS);
    }

    /**
     * Para o auto-avanço.
     */
    function stopAutoAdvance() {
      if (autoAdvanceTimer) {
        clearInterval(autoAdvanceTimer);
        autoAdvanceTimer = null;
      }
    }

    // ── Bind: clique nos indicadores ─────────────────────────
    indicators.forEach(function (indicator) {
      indicator.addEventListener('click', function () {
        var idx = parseInt(indicator.getAttribute('data-indicator-index'), 10);
        if (!isNaN(idx)) {
          goToSlide(idx);
          stopAutoAdvance();
          startAutoAdvance(); // Reinicia o timer após clique manual
        }
      });

      indicator.addEventListener('keydown', function (e) {
        // Navegação por teclado nos indicadores
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var next = currentIndex + 1 >= slides.length ? 0 : currentIndex + 1;
          goToSlide(next);
          if (indicators[next]) indicators[next].focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;
          goToSlide(prev);
          if (indicators[prev]) indicators[prev].focus();
        }
      });
    });

    // ── Pause no hover/focus ──────────────────────────────────
    carousel.addEventListener('mouseenter', stopAutoAdvance);
    carousel.addEventListener('mouseleave', startAutoAdvance);
    carousel.addEventListener('focusin', stopAutoAdvance);
    carousel.addEventListener('focusout', startAutoAdvance);

    // Pausa também quando section inteira recebe foco ou hover
    if (section) {
      section.addEventListener('mouseenter', stopAutoAdvance);
      section.addEventListener('mouseleave', startAutoAdvance);
    }

    // ── Inicialização ─────────────────────────────────────────
    // Garante que apenas o primeiro slide está visível
    slides.forEach(function (slide, i) {
      if (i !== 0) {
        slide.classList.remove('custom-claims-slide--active');
        slide.setAttribute('hidden', '');
      } else {
        slide.classList.add('custom-claims-slide--active');
        slide.removeAttribute('hidden');
      }
    });

    updateIndicators(0);
    startAutoAdvance();
  }

  // ── Bootstrap ─────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  // Suporte a Shopify Section Events (Theme Editor)
  document.addEventListener('shopify:section:load', function (e) {
    var carousel = e.target ? e.target.querySelector('[data-claims-carousel]') : null;
    if (carousel) initSingleCarousel(carousel);
  });

})();
